import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("b", { class: "text-color-primary" }, "本单金额：", -1)
const _hoisted_3 = { class: "text-color-primary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_AddressPicker = _resolveComponent("AddressPicker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_ResponsiveRow = _resolveComponent("ResponsiveRow")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_EditTable = _resolveComponent("EditTable")!
  const _component_Uploader = _resolveComponent("Uploader")!
  const _component_page_card = _resolveComponent("page-card")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_app_page = _resolveComponent("app-page")!

  return (_openBlock(), _createBlock(_component_app_page, null, {
    main: _withCtx(() => [
      _createVNode(_component_page_card, { title: "订单信息" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form, {
            model: _ctx.formData,
            "label-width": "100px",
            rules: _ctx.rules,
            ref: "formRef"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ResponsiveRow, { col: { props: { xs: 24, sm: 24, md: 8, lg: 8, xl: 8 }} }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "客户款号：",
                    prop: "customerStyleCode"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.customerStyleCode,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.customerStyleCode) = $event)),
                        placeholder: "请输入客户款号",
                        maxlength: "30",
                        clearable: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "客户合同号：",
                    prop: "customerContractCode"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.customerContractCode,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.customerContractCode) = $event)),
                        placeholder: "请输入客户合同号",
                        maxlength: "30",
                        clearable: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 8 }),
                  _createVNode(_component_el_form_item, {
                    label: "联系人：",
                    prop: "contactName"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.contactName,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.contactName) = $event)),
                        placeholder: "请输入联系人",
                        clearable: "",
                        maxlength: "30"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "联系电话：",
                    prop: "contactPhone"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.contactPhone,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.contactPhone) = $event)),
                        placeholder: "请输入联系电话",
                        maxlength: "11",
                        type: "number",
                        clearable: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "收货地址：",
                        prop: "address"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_1, [
                            _createVNode(_component_AddressPicker, {
                              province: _ctx.formData.postProvince,
                              "onUpdate:province": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.postProvince) = $event)),
                              city: _ctx.formData.postCity,
                              "onUpdate:city": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.postCity) = $event)),
                              area: _ctx.formData.postArea,
                              "onUpdate:area": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.postArea) = $event))
                            }, null, 8, ["province", "city", "area"]),
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.formData.postAddressDetail,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.postAddressDetail) = $event)),
                              placeholder: "请输入详细地址，如门牌号",
                              clearable: "",
                              class: "margin-left-10"
                            }, null, 8, ["modelValue"])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "生产经理：",
                    prop: "directorId"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.directorId,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.directorId) = $event)),
                        placeholder: "请输入生产经理",
                        clearable: "",
                        remote: "",
                        filterable: "",
                        loading: _ctx.fuzzyLoading,
                        "remote-method": _ctx.fuzzyRemoteMethod
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fuzzyResponse, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              value: item.value,
                              label: `${item.label}(${item.userCode})`
                            }, null, 8, ["value", "label"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "loading", "remote-method"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "生产跟单：",
                    prop: "merchandiserId"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.merchandiserId,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.merchandiserId) = $event)),
                        placeholder: "请输入生产跟单",
                        clearable: "",
                        remote: "",
                        filterable: "",
                        loading: _ctx.fuzzyLoading,
                        "remote-method": _ctx.fuzzyRemoteMethod
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fuzzyResponse, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              value: item.value,
                              label: `${item.label}(${item.userCode})`
                            }, null, 8, ["value", "label"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "loading", "remote-method"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ResponsiveRow, { col: { props: { xs: 24, sm: 12, md: 8, lg: 8, xl: 8 }} }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "紧急程度：",
                    prop: "emergencyLevel"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio_group, {
                        modelValue: _ctx.formData.emergencyLevel,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.emergencyLevel) = $event))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.EMERGENCY_LEVEL_LIST, (item) => {
                            return (_openBlock(), _createBlock(_component_el_radio, {
                              key: item.value,
                              label: item.value
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.label), 1)
                              ]),
                              _: 2
                            }, 1032, ["label"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "交付方式：",
                    prop: "deliveryType"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio_group, {
                        modelValue: _ctx.formData.deliveryType,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.deliveryType) = $event))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.DELIVERY_TYPE_LIST, (item) => {
                            return (_openBlock(), _createBlock(_component_el_radio, {
                              key: item.value,
                              label: item.value
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.label), 1)
                              ]),
                              _: 2
                            }, 1032, ["label"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "生产环节：",
                    prop: "productChainList"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_checkbox_group, {
                        modelValue: _ctx.formData.productChainList,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.productChainList) = $event))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.PRODUCT_CHAIN_LIST, (item) => {
                            return (_openBlock(), _createBlock(_component_el_checkbox, {
                              key: item.value,
                              label: item.value
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.label), 1)
                              ]),
                              _: 2
                            }, 1032, ["label"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "支付方式：",
                    prop: "paymentType"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.paymentType,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.paymentType) = $event)),
                        placeholder: "请选择支付方式"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paymentMethodList, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.valueCode,
                              value: item.valueCode,
                              label: item.value
                            }, null, 8, ["value", "label"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "接单主体：",
                    prop: "orderMainstay"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.orderMainstay,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.orderMainstay) = $event))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.receivingEntityList, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.valueCode,
                              value: item.valueCode,
                              label: item.value
                            }, null, 8, ["value", "label"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 8 }),
                  _createVNode(_component_el_form_item, { label: "开具发票：" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_switch, {
                        modelValue: _ctx.formData.invoice,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.invoice) = $event)),
                        "active-color": "#13ce66",
                        "inactive-color": "#ff4949",
                        "active-value": "1",
                        "inactive-value": "0"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  (_ctx.formData.invoice === _ctx.YES_OR_NO_NUMBER_ENUM.YES)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 0,
                        label: "发票抬头：",
                        prop: "invoiceTitle"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.invoiceTitle,
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formData.invoiceTitle) = $event)),
                            maxlength: 30,
                            placeholder: "输入发票抬头",
                            clearable: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.formData.invoice === _ctx.YES_OR_NO_NUMBER_ENUM.YES)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 1,
                        label: "税点：",
                        prop: "taxPointRate"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.formData.taxPointRate,
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formData.taxPointRate) = $event)),
                            placeholder: "请选择税点",
                            clearable: ""
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.taxPointList, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.valueCode,
                                  value: item.value,
                                  label: item.value
                                }, null, 8, ["value", "label"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_form_item, { label: "允许溢出：" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_switch, {
                        modelValue: _ctx.formData.allowOverflow,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formData.allowOverflow) = $event)),
                        "active-color": "#13ce66",
                        "inactive-color": "#ff4949",
                        "active-value": "1",
                        "inactive-value": "0"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "订单号：" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.formData.orderCode), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "款式：" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.formData.styleCode), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "单量：" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.formData.quantity) + " " + _toDisplayString(_ctx.formData.unit), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, null, {
                    label: _withCtx(() => [
                      _hoisted_2
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("b", _hoisted_3, _toDisplayString(_ctx.$filters.toThousands(_ctx.formData.orderAmount)) + " 元", 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules"]),
          _createVNode(_component_el_form, {
            ref: "tableRef",
            rules: _ctx.rules,
            model: { tableData: _ctx.tableData }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ResponsiveRow, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, {
                    span: 24,
                    class: "margin-bottom-10"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: _ctx.handleAddRow
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("添加行")
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: _ctx.handleAddSize
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("添加尺码")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_EditTable, {
                        standardSizeLists: _ctx.standardSizeArr,
                        suitableColors: _ctx.suitableColors,
                        demandDetailId: _ctx.formData.demandDetailId,
                        tableData: _ctx.tableData,
                        onRemoveSize: _ctx.handleRemoveSize,
                        onRemoveRow: _ctx.handleRemoveRow,
                        onUpdateSumQuantity: _ctx.updateSumQuantity
                      }, null, 8, ["standardSizeLists", "suitableColors", "demandDetailId", "tableData", "onRemoveSize", "onRemoveRow", "onUpdateSumQuantity"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["rules", "model"]),
          _createVNode(_component_page_card, { title: "审批信息" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form, {
                model: _ctx.formData,
                "label-width": "110px",
                rules: _ctx.rules,
                ref: "spRef"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ResponsiveRow, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "飞书审批编号",
                        prop: "serialNumber"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.serialNumber,
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.formData.serialNumber) = $event)),
                            maxlength: 20,
                            placeholder: "请输入飞书审批编号"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 16 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: "审批截图",
                            prop: "_images"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Uploader, {
                                modelValue: _ctx.formData._images,
                                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.formData._images) = $event)),
                                limit: 3,
                                size: "mini",
                                sizeLimit: 20,
                                accept: ".png, .jpg, .jpeg",
                                checkAccept: true,
                                tips: "最多可以上传 3 张图片, 支持png、jpg、jpeg图片格式"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model", "rules"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    ffooter: _withCtx(() => [
      _createVNode(_component_el_row, {
        type: "flex",
        justify: "center",
        style: {"width":"100%"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, {
            plain: "",
            onClick: _ctx.handleBack
          }, {
            default: _withCtx(() => [
              _createTextVNode("返 回")
            ]),
            _: 1
          }, 8, ["onClick"]),
          (_ctx.$has(_ctx.permissionConfig.SUBMIT))
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "primary",
                disabled: !_ctx.isCreditCustomer,
                onClick: _ctx.handleSubmit
              }, {
                default: _withCtx(() => [
                  _createTextVNode("提 交")
                ]),
                _: 1
              }, 8, ["disabled", "onClick"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}